<template>
  <vx-tooltip style="display: flex; justify-content: center;" text="View Detail">
    <vs-button
      style="float: left"
      @click="viewDetailHandler()"
      size="small"
      type="border"
      class="m-1"
    >
      View</vs-button
    >
  </vx-tooltip>
</template>

<script>
export default {
  name: 'ViewTreatmentHistoryDetailButton',
  props: {
    checkInId: {
      type: String,
    },
    patientId: {
      type: String,
    },
    dateRange: {
      type: String,
    },
    month: {
      type: String,
    },
    year: {
      type: Number,
    },
    clinicId: {
      type: String,
    },
    clinicName: {
      type: String,
    },
    activeView: {
      type: String,
    },
    appointmentId: {
      type: String,
    },
  },
  data() {
    return {
      orgId: null,
    };
  },
  methods: {
    viewDetailHandler() {
      let backRoute = '';
      let userType = this.$store.state.AppActiveUser.userType;
      const role =  localStorage.getItem(
      `${process.env.VUE_APP_ACCESS_TOKEN_NAME}Role`
      );

      if(role === 'Org Owner'){
        userType = 'org-owner';
      }
      
      switch (userType) {
        case 'org-owner':
          backRoute = 'OrgOwnerDoctorEdit';
          break;
        case 'doctor':
          backRoute = 'DoctorTreatmentHistory';
          break;
        case 'nurse':
          backRoute = 'NurseTreatmentHistory';
          break;
        case 'basic':
          backRoute = 'BasicEditClinic';
          break;
        case 'superAdmin':
          userType = 'super-admin';
          backRoute = 'SuperAdminClinicTreatmentHistory';
          break;
        case 'admin':
          backRoute = 'AdminClinicTreatmentHistory';
          break;
        case 'franchise':
          backRoute = 'FranchiseClinicTreatmentHistory';
          break;
        case 'subFranchise':
          userType = 'franchise';
          backRoute = 'FranchiseClinicTreatmentHistory';
          break;
        default:
          break;
      }

      this.$router.push({
        path: `/${userType}/patients/${this.patientId}/treatment/${this.checkInId}`,
        query: {
          backRoute: backRoute,
          clinicId: this.clinicId,
          clinicName: this.clinicName,
          year: this.year,
          month: this.month,
          dateRange: this.dateRange,
          activeView: this.activeView,
          appointmentId: this.appointmentId,
        },
      });
    },
  },
  created() {
    this.orgId = localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`);
  },
};
</script>
